require.register("app/restaurant/analyse/invoice/Form", function(exports, require, module){
  $0
  
});

